import { Component, Vue } from 'vue-property-decorator';
import ParticipantService from '@/services/participant.service';
import { RecapDTO } from '@/models/RecapDTO';
import ParticipantAdministrative from '@/components/ParticipantAdministrative/ParticipantAdministrative';
import MedicalData from '@/components/MedicalData/MedicalData';
import Question from '@/components/Question/Question';
import LocalStoreService from '@/store/local.store';
import { store } from '@/store/store';
import ProInclusion from '@/components/ProInclusion/ProInclusion';
import DocumentService from '@/services/documentService';
import { FileDataInterface } from '@/store/interfaces/filedata.interface';
import BlobConverter from '@/utils/blobconverter';
import { McsisRole } from '@/models/constants/McsisRole';
import ParticipantContact from '@/components/ParticipantContact/ParticipantContact';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import { InclusionTypes, TemplateTypes, ProInclusionTypes } from '@/models/VariousEnum';
import InformationBlock from '@/components/InformationBlock/InformationBlock';
import { isInRole } from '@/plugins/auth';
import { relativeTimeThreshold } from 'moment';
import { getCorrespondenceLanguagesBySu } from '@/config/app.config';

@Component({
  components: {
    ParticipantAdministrative,
    MedicalData,
    Question,
    ProInclusion,
    ParticipantContact,
    SectionTitle,
    InformationBlock,
  },
})
export default class Recap extends Vue {
  public partId!: number;
  public errorMessage: string = '';
  public error: boolean = false;
  public recap: RecapDTO = {} as RecapDTO;
  public roleParticipant: string = McsisRole[McsisRole.Participant];
  public isParticipant: boolean = true;

  protected get isIdentified(): boolean {
    return store.state.isIdentified;
  }
  protected get isAuthenticated(): boolean {
    return store.state.isAuthenticated;
  }
  protected get isColonoscopyModeActive() {
    return store.state.isColonoscopyMode;
  }

  protected get mustOrderFit(): boolean {
    if (this.recap.proInclusion === undefined) {
      return true;
    }

    if (
      (
          this.recap.proInclusion.choice === ProInclusionTypes.fit
          && this.recap.proInclusion.testFitNumber !== null
          && this.recap.proInclusion.testFitNumber !== ''
      ) ||
      this.recap.proInclusion.choice === ProInclusionTypes.colo ||
      this.recap.proInclusion.choice === ProInclusionTypes.advice ||
      (this.isColonoscopyModeActive && store.state.inclusionType === 'colonoscopy' && this.isParticipant)
    ) {
      // We already have a FIT number, so the fit was given to the participant,
      // therefore there's no need to order a FIT.
      // In case of colo inclusion, there's no need to order a FIT also.
      // In case of advice inclusion, there's no need to order a FIT also.
      // In case of coloscopy mode, if the participant is in colo inclusion, we don't order a FIT
      return false;
    }

    return true;
  }



  protected async mounted() {
    this.partId = Number(this.$route.params.partId);

    ParticipantService.fetchPublicInclusionContent(this.partId)
      .then((response: any) => {
        this.recap = response as RecapDTO;
    });
    this.isParticipant = await this.$isInRole(McsisRole.Participant).then((x: boolean) => x );
  }

  protected async onSubmit(): Promise<void> {
    const correspondenceLanguages = getCorrespondenceLanguagesBySu(this.$route.params.screening);
    if (this.recap.identification.correspondenceLang === '' && correspondenceLanguages.length === 1) {
      await DocumentService.preparePDF(this.partId,
        correspondenceLanguages[0].toString(),
        false,
        this.$route.params.screening);
    } else {
      await DocumentService.preparePDF(this.partId,
        this.recap.identification.correspondenceLang,
        false,
        this.$route.params.screening);
    }
    this.sendToQueue();
  }

  protected sendToQueue() {
    ParticipantService.sendToQueue(this.partId)
      .then(() => {
        // Set type of inclusion: 'Inclusion' / 'Exclusion' / 'Refusal' / Advice
        const inclusionType = this.recap.proInclusion.choice === ProInclusionTypes.advice ? 'Advice' : 'Inclusion';
        LocalStoreService.setItem(LocalStoreService.localItemKeys.inclusionType, inclusionType);
        this.$router.push({
          name: 'confirmation',
          params: {
            screening: this.$route.params.screening,
          },
          query: {
            mustOrderFit: this.mustOrderFit.toString(),
          },
        });
      });
  }

  protected showProInclusion(): boolean {
    if (this.recap && this.recap.questions) {
      return this.recap.questions.every((x) => x.answer === '0') && this.isAuthenticated;
    } else {
      return false;
    }
  }

  protected hasCustomConsent(): boolean {
    return store.state.hasCustomConsent;
  }

  protected getInclusionKey(): string {
    if (store.state.inclusionType === InclusionTypes.fit) {
      return 'inclusion.fit';
    } else if (store.state.inclusionType === InclusionTypes.colo) {
      return 'inclusion.colo';
    } else {
      return '';
    }
  }
}
